import classNames from "classnames";
import { noop } from "lodash";
import { t } from "@/i18n-js/instance";
import { LeaveSpaceConfirmationModal } from "@circle-react/components/Spaces/LeaveSpaceConfirmationModal";
import type { Space } from "@circle-react/types";
import { Button } from "@circle-react-uikit/Button";

export interface SpaceCardButtonsCurrentUserProps {
  isAdmin: boolean;
  isPrivate: boolean;
  isSpaceMember: boolean;
  isViewOnlyMasquerading: boolean;
  joinSpace: () => void;
  shouldShowDeletePopup: boolean;
  space: Space;
  spaceAccessViaPaywall: boolean;
  toggleDeletePopup: () => void;
}

export const SpaceCardButtonsCurrentUser = ({
  isSpaceMember,
  spaceAccessViaPaywall,
  shouldShowDeletePopup,
  toggleDeletePopup,
  space,
  joinSpace,
  isViewOnlyMasquerading,
  isPrivate,
  isAdmin,
}: SpaceCardButtonsCurrentUserProps) => {
  const shouldShowLeaveButton =
    isSpaceMember && !!space.policies?.can_leave_space;
  const shouldShowJoinButton =
    (!spaceAccessViaPaywall && !isPrivate) || isAdmin;

  if (shouldShowLeaveButton) {
    return (
      <div className="space-card__actions">
        <LeaveSpaceConfirmationModal
          show={shouldShowDeletePopup}
          onClose={toggleDeletePopup}
          space={space}
        />
        <Button
          type="button"
          variant="secondary"
          onClick={isViewOnlyMasquerading ? noop : toggleDeletePopup}
        >
          {t("leave_this_space")}
        </Button>
      </div>
    );
  }

  if (shouldShowJoinButton) {
    return (
      <div className="space-card__actions">
        <Button
          variant="primary"
          onClick={isViewOnlyMasquerading ? noop : joinSpace}
          className={classNames({
            "cursor-not-allowed": isViewOnlyMasquerading,
          })}
        >
          {t("join_space")}
        </Button>
      </div>
    );
  }

  return null;
};
